import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from "rxjs/operators";
import { GarantieDetail } from "src/app/parametrage/core/model/garanties/GarantieDetail";
import { NatureGarantieChamp } from "src/app/parametrage/core/model/garanties/NatureGarantieChamp";
import { NatureGarantie } from "src/app/parametrage/core/model/garanties/nature-garantie";
import { GarantieService } from "src/app/parametrage/core/service/garantie.service";
import { NatureGarantieService } from "src/app/parametrage/core/service/nature-garantie.service";
import {
  CustomAdapter,
  CustomDateParserFormatter,
} from "src/app/shared/adapters/datepicker-adapter";

@Component({
  selector: "app-add-garantie-detail",
  templateUrl: "./add-garantie-detail.component.html",
  styleUrls: ["./add-garantie-detail.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class AddGarantieDetailComponent implements OnInit {
  form: FormGroup;
  pressButton: Boolean = false;
  requestId: number;
  //From row parameter
  garantie: GarantieDetail;
  natureGaranties: NatureGarantie[];
  selectedNatureGarantie: NatureGarantie;
  selectedNatureGarantieId: number;
  natureGarantieChamps: NatureGarantieChamp[] = [];
  errorMessage: string;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private _garantieService: GarantieService,
    private _natureGarantieService: NatureGarantieService,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit() {
    this.getAllNatureWithGarantieChamps();
  }

  ChangeSelectedNatureGarantie() {
    if (this.natureGaranties) {
      this.selectedNatureGarantie = null;
      this.natureGarantieChamps = [];
      if (this.selectedNatureGarantieId) {
        this.selectedNatureGarantie = this.natureGaranties.find(
          (n) => n.id == this.selectedNatureGarantieId
        );
        this.natureGarantieChamps =
          this.selectedNatureGarantie.natureGarantieChamps;
        if (this.natureGarantieChamps)
          this.natureGarantieChamps.sort((a, b) => a.position - b.position);

        const formGroupControls = {};
        this.natureGarantieChamps.forEach((champ) => {
          const control = new FormControl(
            null,
            champ.obligatoire ? Validators.required : null
          );
          formGroupControls[champ.codeChamp] = control;
          //this.form.addControl(champ.codeChamp, control);
        });
        this.form = this.fb.group(formGroupControls);
      }
    }
  }

  getAllNatureWithGarantieChamps() {
    this._natureGarantieService
      .getAllNatureWithGarantieChamps()
      .subscribe((data) => {
        this.natureGaranties = data;
      });
  }

  onSubmit() {
    this.submitted = true;
    if (!this.selectedNatureGarantieId) {
      this.errorMessage = "Veuillez sélectionner la nature de la garantie";
      return;
    }
    console.log(this.form.value);
    this.findInvalidControls();
    if (this.form.invalid) {
      return;
    }
    this.spinner.show();
    this._garantieService
      .addGarantieDetail(
        this.requestId,
        this.selectedNatureGarantieId,
        this.form.value
      )
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
        }
      );
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
        const invalidControl = this.natureGarantieChamps.find(
          (n) => n.codeChamp == name
        );
        console.log(controls);
        this.errorMessage = `Le champ [${invalidControl.libelleChamp}] est obligatoire de type [${invalidControl.typeChamp}].`;
        return;
      }
    }
    //console.log(invalid);
  }

  getFile(e) {
    let extensionAllowed = { xlsx: true, xls: true };

    var nam = e.target.files[0].name.split(".").pop().toLowerCase();
    if (!extensionAllowed[nam]) {
      alert(
        "SVP entrez un fichier au format excel " +
          Object.keys(extensionAllowed) +
          "."
      );
      this.form.controls["fichier"].setValue(null, { emitEvent: false });
      return;
    }

    //this.form.controls["fichier"].setValue(e.target.files[0]);
  }

  getFileGarantie(e) {
    let extensionAllowed = { xlsx: true, xls: true };

    var nam = e.target.files[0].name.split(".").pop();
    if (!extensionAllowed[nam]) {
      alert(
        "SVP entrez un fichier au format excel " +
          Object.keys(extensionAllowed) +
          "."
      );
      this.form.controls["fichierGarantie"].setValue(null, {
        emitEvent: false,
      });
      return;
    }

    //this.form.controls["fichier"].setValue(e.target.files[0]);
  }
}
